import type { NudgeEventProps } from '../types';

export const mapNudgeProps = ({
  errorNudgeType,
  nudgeType,
}: NudgeEventProps) => ({
  ...(errorNudgeType && nudgeType === 'Error' ? { errorNudgeType } : {}),
  nudgeType,
});
